import { MessageCircle, Phone, ShieldCheck } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, waLink } from "@/lib/site";

export default function Hero() {
  return (
    <section id="inicio" className="relative min-h-[100svh] flex items-center overflow-hidden">
      <img
        src="/images/guincho-asa-delta-noite.jpeg"
        alt="Reboque Asa Delta da Brasil Transportes resgatando veículo à noite em Belém"
        className="absolute inset-0 w-full h-full object-cover object-center"
        fetchpriority="high"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/55 to-black/15" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-black/40" />

      <div className="relative max-w-7xl mx-auto px-4 w-full pt-28 pb-20">
        <div className="max-w-3xl">
          <img
            src="/images/logo.png"
            alt="Brasil Transportes - Guincho e Reboque em Belém"
            data-testid="hero-logo"
            className="h-24 md:h-32 w-auto object-contain mx-auto md:mx-0"
          />
          <p
            data-testid="hero-badge"
            className="mt-6 inline-flex items-center gap-2 border border-[#FEFB0E]/50 bg-[#FEFB0E]/10 text-[#FEFB0E] uppercase tracking-widest text-xs md:text-sm font-semibold px-4 py-2 rounded-full"
          >
            Reboque Asa Delta • Plataforma • Motos
          </p>

          <h1 className="font-bebas text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight uppercase mt-6">
            Guincho e Reboque em <span className="text-[#FEFB0E]">Belém e Região</span>
          </h1>

          <p className="mt-6 text-base md:text-lg text-neutral-300 leading-relaxed max-w-xl">
            Resgate rápido de veículos, motos e utilitários com Reboque Asa Delta e Plataforma.
            Atendimento em Belém, Ananindeua, Marituba e Região Metropolitana.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-btn"
              className="flex items-center justify-center gap-3 bg-[#50CF08] hover:bg-[#42B006] text-white font-extrabold uppercase text-lg md:text-xl px-8 py-4 rounded-md transition-all duration-300 hover:-translate-y-0.5 shadow-[0_10px_40px_rgba(80,207,8,0.35)] focus:outline-none focus:ring-2 focus:ring-[#FEFB0E]"
            >
              <MessageCircle className="w-6 h-6" />
              Chamar guincho agora
            </a>
            <a
              href={PHONE_TEL}
              data-testid="hero-call-btn"
              className="flex items-center justify-center gap-3 bg-[#FEFB0E] hover:bg-[#D8D50A] text-black font-extrabold uppercase text-lg md:text-xl px-8 py-4 rounded-md transition-all duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-white"
            >
              <Phone className="w-6 h-6" />
              Ligar agora
            </a>
          </div>

          <p className="mt-6 flex items-center gap-2 text-sm md:text-base text-neutral-400">
            <ShieldCheck className="w-5 h-5 text-[#50CF08] shrink-0" />
            Atendimento rápido para situações de emergência e transporte de veículos.
          </p>

          <a
            href={PHONE_TEL}
            data-testid="hero-phone-display"
            className="mt-8 inline-block font-bebas text-4xl md:text-5xl tracking-wide text-white hover:text-[#FEFB0E] transition-colors"
          >
            {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </section>
  );
}
